module.exports = __webpack_public_path__ + "images/014a6cc7bd65b34329a0d788c5463afa021b0328ae7d2d5638c4f7607136449e.svg";